module.exports = __webpack_public_path__ + "static/media/10.d1b43a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/10.jpg
// module id = 271
// module chunks = 0